<template>
  <div>
    <div class="view-header">
      <h1 class="is-size-5 is-expanded">Service Request</h1>
      <router-link
        :to="`/request/service/edit/${$route.params.id}`"
        class="button is-small is-primary is-uppercase"
        >Edit</router-link
      >
    </div>
    <div class="box">
      <table class="table is-fullwidth">
        <tr>
          <th>Engineer</th>
          <td>
            {{ service.engineer.employeeId }}, {{ service.engineer.name }},
            {{ service.engineer.mobile }}
          </td>
        </tr>
        <tr>
          <th>Visit Date</th>
          <td>{{ service.visitedAt | date }}</td>
        </tr>
        <tr>
          <th>Customer Name</th>
          <td>{{ service.customerName }}</td>
        </tr>
        <tr>
          <th>Contact Person</th>
          <td>{{ service.contactPerson }}</td>
        </tr>
        <tr>
          <th>Contact Number</th>
          <td>{{ service.contactNumber }}</td>
        </tr>
        <tr>
          <th>Principals</th>
          <td>{{ service.principals }}</td>
        </tr>
        <tr>
          <th>Instrument</th>
          <td>{{ service.instrument }}</td>
        </tr>
        <tr>
          <th>Model</th>
          <td>{{ service.modelNumber }}</td>
        </tr>
        <tr>
          <th>Serial</th>
          <td>{{ service.serialNumber }}</td>
        </tr>
        <tr>
          <th>Service Type</th>
          <td>{{ service.serviceType }}</td>
        </tr>
        <tr>
          <th>Complaint</th>
          <td><pre>{{ service.complaint || '' }}</pre></td>
        </tr>
        <tr>
          <th>Observations</th>
          <td>
            <pre>{{ service.observations }}</pre>
          </td>
        </tr>
        <tr>
          <th>Work Done</th>
          <td>
            <pre>{{ service.workDone }}</pre>
          </td>
        </tr>
        <tr>
          <th>Customer Comments</th>
          <td>
            <pre>{{ service.customerComments }}</pre>
          </td>
        </tr>
        <tr>
          <th>Status</th>
          <td>{{ service.status }}</td>
        </tr>
        <tr>
          <th>Quotations</th>
          <td>
            <pre>{{ service.quotations }}</pre>
          </td>
        </tr>
        <tr>
          <th>Visit Type</th>
          <td>{{ service.visitType }}</td>
        </tr>
        <tr>
          <th>Warranty From</th>
          <td v-if="service.warrantyStart">
            {{ service.warrantyStart | date }}
          </td>
          <td class="has-text-grey">N/A</td>
        </tr>
        <tr>
          <th>Warranty To</th>
          <td v-if="service.warrantyEnd">{{ service.warrantyEnd | date }}</td>
          <td class="has-text-grey">N/A</td>
        </tr>
        <tr>
          <th>Attachments</th>
          <td>
            <div class="columns is-multiline">
              <div
                class="column is-3"
                v-for="attachment in service.attachments"
                :key="attachment"
              >
                <attachment-tile :attachment="attachment"></attachment-tile>
              </div>
            </div>
          </td>
        </tr>
      </table>

      <div class="is-flex">
        <div class="is-expanded">
          <router-link to="/request/service" class="button is-borderless"
            >Back</router-link
          >
        </div>
        <div class="is-expanded has-text-right"></div>
      </div>
    </div>
  </div>
</template>
<script>
import AttachmentTile from "./components/attachment";
export default {
  components: {
    AttachmentTile
  },
  data() {
    return {
      service: {
        engineer: {
          name: "",
          employeeId: "",
          mobile: ""
        },
        warranty: {
          start: "",
          end: ""
        }
      }
    };
  },
  mounted() {
    let component = this;
    component.$store
      .dispatch("service/show", component.$route.params.id)
      .then(response => {
        component.service = response.data;
      });
  }
};
</script>
